import { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";

interface Props {
  x: number;
  y: number;
  width: number;
  height: number;
  value: String;
  pickListArray: Array<String>;
  editable: boolean;
  picklistElementIndex: number;
  coordinateId: number;
  isRequired: boolean;
  handlePicklistValueChange: Function;
}

export const PicklistPad = ({
  x, y, width, height, editable,
  value: selectedValue = "",
  pickListArray,
  handlePicklistValueChange,
  picklistElementIndex,
  isRequired,
}: Props) => {
  const [picklistOpen, setPicklistOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [menuPos, setMenuPos] = useState({ top: 0, left: 0, width: 0, maxHeight: 117 });
  console.log("PicklistPad props:", { x, y, width, height });
  const toggleDropDown = () => {
    console.log("toggleDropDown called");
    console.log("picklistOpen:", picklistOpen);
    console.log("buttonRef.current:", buttonRef.current);
    console.log("portalRoot:", document.getElementById("portal-root"));
    if (!picklistOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      console.log("rect values:", { top: rect.top, bottom: rect.bottom, left: rect.left, width: rect.width });

      const viewportPadding = 8;
      const optionHeight = 37;
      const desiredHeight = Math.min(pickListArray.length * optionHeight, 180);
      const spaceBelow = window.innerHeight - rect.bottom - viewportPadding;
      const spaceAbove = rect.top - viewportPadding;
      const openAbove = spaceBelow < desiredHeight && spaceAbove > spaceBelow;
      const menuWidth = Math.min(rect.width, window.innerWidth - viewportPadding * 2);
      const maxHeight = Math.max(
        optionHeight,
        Math.min(desiredHeight, openAbove ? spaceAbove : spaceBelow)
      );

      setMenuPos({
        top: openAbove ? rect.top - maxHeight : rect.bottom,
        left: Math.min(
          Math.max(viewportPadding, rect.left),
          window.innerWidth - menuWidth - viewportPadding
        ),
        width: menuWidth,
        maxHeight,
      });
    }
    setPicklistOpen((prev) => !prev);
  };

  useEffect(() => {
    console.log("picklistOpen state changed to:", picklistOpen);
    if (!picklistOpen) return;
    const handler = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (
        !target.closest(".picklist-portal-menu") &&
        !target.closest(".picklist-toggle-btn")
      ) {
        setPicklistOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [picklistOpen]);

  const portalMenu =
    picklistOpen
      ? ReactDOM.createPortal(
        <div
          className="picklist-portal-menu"
          style={{
            position: "fixed",
            top: menuPos.top,      
            left: menuPos.left,    
            minWidth: menuPos.width,
            maxHeight: menuPos.maxHeight, 
            overflowY: "auto",
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            borderRadius: "4px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            zIndex: 999999,
          }}
        >
          {pickListArray.map((item: String, index: number) => (
            <div
              key={index}
              onMouseDown={() => {
                handlePicklistValueChange(picklistElementIndex, item);
                setPicklistOpen(false);
              }}
              style={{
                padding: "8px 16px",
                cursor: "pointer",
                fontSize: "14px",
                color: "#333",
                borderBottom: "1px solid #f0f0f0",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#f5f5f5")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "#fff")
              }
            >
              {item}
            </div>
          ))}
        </div>,
        document.body
      )
      : null;

  return (
    <>
      <div
        style={{
          position: "absolute",
          top: y,
          left: x,
          zIndex: 10,
        }}
      >
        <div className={editable ? "" : "readonly-container-textarea"}>
          <span
            className="cannot-edit"
            style={editable ? { display: "none" } : {}}
          >
            Cannot Edit
          </span>

          <span style={{ position: "relative", display: "inline-block" }}>
            <button
              ref={buttonRef}
              className="picklist-toggle-btn"
              onClick={toggleDropDown}
              disabled={!editable}
              style={{
                backgroundColor: "#22a699",
                color: "white",
                height: height,
                width: width,
                padding: "0 8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                border: "none",
                borderRadius: "5px",
                cursor: editable ? "pointer" : "not-allowed",
                fontWeight: "bold",
              }}
            >
              <span
                style={{
                  fontSize: "smaller",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  flex: 1,
                  textAlign: "left",
                }}
              >
                {selectedValue ? selectedValue : "Select Options"}
              </span>
              <span style={{ fontSize: "10px", marginLeft: "4px" }}>▼</span>
            </button>

            {isRequired && (
              <span
                style={{
                  position: "absolute",
                  fontWeight: "bold",
                  color: "#BB2525",
                  fontSize: "1.2rem",
                  top: "-10px",
                  right: "-10px",
                  pointerEvents: "none",
                }}
              >
                *
              </span>
            )}
          </span>
        </div>
      </div>

      {portalMenu}
    </>
  );
};
